<template>
  <section class="dispatch-container">
    <RobotBase v-if="step == 1" @click="nextStepHandle(2)" />
    <OrderList v-if="step == 2" @config="orderConfigHandle" />

    <OrderConfig v-if="showOrderConfig == true" :data="orderConfigData" @cancel="orderConfigCancelHandle" />
    <OrderConfigNotification />
  </section>
</template>

<script setup>
  import { onMounted, ref, watch } from 'vue';
  import * as Request from '@/assets/request';
  import RobotBase from '@/pages/dispatch/components/robotbase';
  import OrderList from '@/pages/dispatch/components/orderlist';
  import OrderConfig from '@/pages/dispatch/components/orderconfig';
  import OrderConfigNotification from '@/pages/dispatch/components/orderconfig/notification.vue';

  const emits = defineEmits([ 'screen' ])

  const step = ref(null)

  // 判断是否有创建过任务；0 - 默认；1 - 没任务；2 - 有任务
  const hasTaskTipFlag = ref(0)
  // 机器列表
  const mathineList = ref([])
  const getMachines = async () => {
    const result = await Request.post({
      url: '/22001/facade/dispatch/machines'
    });
    if(result?.code != 200) return;
    
    if(result?.data?.length > 0) {
      mathineList.value = result.data;

      result.data.map(item => {
        if(item.createdTask) {
          hasTaskTipFlag.value = 2
        }
      })
    }
    if(hasTaskTipFlag.value != 2) {
      hasTaskTipFlag.value = 1
    }
  }
  onMounted(() => {
    getMachines();
  });
  const nextStepHandle = (targetStep) => {
    if(!targetStep) return;

    if(hasTaskTipFlag.value == 2) {
      emits('screen')
    }else{
      step.value = targetStep
    }
  }
  watch(() => hasTaskTipFlag.value, () => {
    nextStepHandle(1)
  })

  /**
   * 提交任务
   */
  const orderConfigData = ref(null)
  const showOrderConfig = ref(false)
  const orderConfigHandle = item => {
    orderConfigData.value = item;
    showOrderConfig.value = true;
  }
  const orderConfigCancelHandle = () => {
    orderConfigData.value = null;
    showOrderConfig.value = false;
  }
</script>

<style scoped lang="less">
  @import "./index.less";
  @import "../../index.less";
</style>
